import React from 'react';
import { Paper, Stack, Typography } from 'components/mui';
import { SREDSummary } from 'api/sred';

interface SREDSummaryCardsProps {
  summary: SREDSummary;
}

function SREDSummaryCards({ summary }: SREDSummaryCardsProps) {
  const cards = [
    { label: 'Projects', value: summary.totalProjects },
    { label: 'Cases', value: summary.totalCases },
    { label: 'Consultants', value: summary.consultantCount },
    { label: 'Total Hours', value: summary.totalHours.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
  ];

  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap' }}>
      {cards.map((card) => (
        <Paper
          key={card.label}
          elevation={1}
          sx={{ p: 2, minWidth: 140, textAlign: 'center', flex: '1 1 0' }}
        >
          <Typography variant="h4" color="primary">
            {card.value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {card.label}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
}

export default SREDSummaryCards;
